import { useState } from 'react';
import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import type { FaqItem } from '@/types/content';

interface FaqPreviewProps {
  items: FaqItem[];
}

export default function FaqPreview({ items }: FaqPreviewProps) {
  const [openId, setOpenId] = useState<string>(items[0]?.id ?? '');

  return (
    <section aria-labelledby="home-faq">
      <SectionHeading
        eyebrow="FAQ"
        title="读者常问的几个问题"
        description="关于来源、核对方式与线索投递，这里是最常被问到的内容。"
        linkTo="/faq"
        linkLabel="查看全部问答"
      />
      <div className="divide-y divide-background-300/70 overflow-hidden rounded-lg border border-background-300/70 bg-background-100">
        {items.map((item) => {
          const open = openId === item.id;
          return (
            <div key={item.id}>
              <button
                type="button"
                onClick={() => setOpenId(open ? '' : item.id)}
                aria-expanded={open}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-200/60"
              >
                <span className="font-heading text-sm font-semibold text-foreground-900 md:text-base">
                  {item.question}
                </span>
                <span className="flex h-5 w-5 shrink-0 items-center justify-center text-primary-600">
                  <i className={open ? 'ri-subtract-line' : 'ri-add-line'} />
                </span>
              </button>
              {open ? (
                <div className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                  {item.answer}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
      <p className="mt-4 font-label text-xs text-foreground-500">
        还有其他疑问？可以{' '}
        <Link to="/contact" className="text-primary-600 underline decoration-primary-300 underline-offset-4">
          直接联系我们
        </Link>
        ，编辑会在两个工作日内回复。
      </p>
    </section>
  );
}